import ModalWrapper from "../Modal/modalWrapper/basicModalWrapper";

const RerunExecutionConfirmModal = ({
  onClose,
  onClickRerun,
  data,
  title,
  fields,
  confirmButtonText = "Re-run",
  confirmButtonColor = "primary",
}) => {
  const handleConfirmAdd = async (data) => {
    await onClickRerun(data);
  };
  
  const getButtonClassName = () => {
    if (confirmButtonColor === "error") {
      return "white bg-red600";
    }
    return "white bg-blue600";
  };
  
  const buttons = [
    {
      label: "Cancel",
      variant: "outline",
      className: "primary",
      onClick: onClose,
    },
    {
      label: confirmButtonText,
      variant: "primary",
      className: getButtonClassName(),
      color: confirmButtonColor,
    },
  ];
  return (
    <ModalWrapper
      open={data?.isModalOpen}
      onClose={onClose}
      title={title}
      fields={fields}
      buttons={buttons}
      onSubmit={handleConfirmAdd}
      containerStyles={{
        width: "450px"
      }}
    />
  );
};

export default RerunExecutionConfirmModal;
